(function () {
  if (window.__floatingTooltipInit) return;
  window.__floatingTooltipInit = true;

  var tip;
  function ensureTip() {
    if (tip) return tip;
    tip = document.createElement('div');
    tip.className = 'floating-tooltip';
    document.body.appendChild(tip);
    return tip;
  }

  function show(target) {
    var text = target.getAttribute('data-floating-tooltip');
    if (!text) return;
    var el = ensureTip();
    el.textContent = text;
    el.classList.add('is-visible');
    var rect = target.getBoundingClientRect();
    var tipRect = el.getBoundingClientRect();
    var top = rect.top - tipRect.height - 8;
    var placement = 'top';
    if (top < 8) {
      top = rect.bottom + 8;
      placement = 'bottom';
    }
    var left = rect.left + rect.width / 2 - tipRect.width / 2;
    var maxLeft = window.innerWidth - tipRect.width - 8;
    if (left < 8) left = 8;
    if (left > maxLeft) left = maxLeft;
    el.style.top = top + 'px';
    el.style.left = left + 'px';
    el.setAttribute('data-placement', placement);
  }

  function hide() {
    if (tip) tip.classList.remove('is-visible');
  }

  document.addEventListener('mouseover', function (e) {
    var t = e.target.closest('[data-floating-tooltip]');
    if (t) show(t);
  });
  document.addEventListener('mouseout', function (e) {
    var t = e.target.closest('[data-floating-tooltip]');
    if (t) hide();
  });
  document.addEventListener('scroll', hide, true);
})();
